import client from './client'
import install from './install'

// 子模块

import api from './api'
import login from './login'

export default class UltronApi {
  constructor (options) {
    if (UltronApi.instance) {
      throw new Error('UltronApi is singleton')
    }
    UltronApi.instance = this
    this.options = options

    client.defaults.baseURL = options.baseURL

    this.api = api
    this.login = login
  }

  static getInstance () {
    return UltronApi.instance
  }
}

UltronApi.instance = null
UltronApi.install = install
